export default __webpack_public_path__ + "static/media/icon-1.ccd1a121.png";